import PropTypes from "prop-types"
import React from "react"
import "../layout.css"
import "./header.css"

const Header = ({ siteTitle, siteIntro, cheerUpMessage }) => (
  <header className="HeaderContainer">
    <a href="https://www.airasia.com/">
      <img src="https://a.staticaa.com/images/logos/airasiacom_logo.svg" className="HeaderLogo" alt="logo" href="https://www.airasia.com/" />
    </a>
    {siteIntro && (
      <p className="Intro">{siteIntro}</p>
    )}
    {siteTitle && (
      <h1 className="Title">{siteTitle}</h1>
    )}
    <p className="CheerUp">{cheerUpMessage}</p>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
  siteIntro: PropTypes.string,
  cheerUpMessage: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
  siteIntro: ``,
  cheerUpMessage: ``,
}

export default Header
